import React from "react";
import { Form } from "react-bootstrap";
import { ReactComponent as SendIcon } from "../assets/icons/send.svg";
import "../ChatMessageInput.css";

export default function ChatMessageInput(props) {
  const { sendMessageHandler, message, setMessage } = props;
  return (
    <div className="chatmessage-container">
      <Form onSubmit={sendMessageHandler} className="chatmessage-form">
        <Form.Control
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="chatmessage-input"
        />

        <button className="send-button" type="submit">
          <SendIcon className="send-icon" />
        </button>
      </Form>
    </div>
  );
}
